import styled from 'styled-components';

export const LandingPageWrapper = styled.div`
	> * {
		margin: 0;
		padding: 0;
		color: #212529;
	}

	> div > div {
		padding: 0 1.5rem;
	}

	position: relative;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	justify-content: center;
	flex-direction: column;

	.index-layout {
		display: flex;
		flex-direction: column;
		align-items: start;
		justify-content: start;
		width: 100%;
	}

	.index-title-container {
		display: flex;
		padding: 0.5rem 0;
		justify-content: center;
		width: 100%;
		font-weight: 500 !important;
		font-size: 1.8rem;
		color: #c7222a;
	}

	.index-carousel {
		padding: 0;
		max-width: 100%;
		${"" /* margin-top: -11vh; */}
	}

	${
		"" /* .index-carousel-message {
		width: 40%;
		padding: 0.7rem;
		border-radius: 0 1rem 1rem 0;
		font-size: 1.4rem;
		background-color: #c7222a;
		color: white;
		position: relative;
	}

	.index-carousel-cta {
		position: relative;
		margin: 1rem 0 0 0.5rem;
	}

	.index-carousel-cta > button {
		padding: 0.25rem 2.5rem;
		border-radius: 0.5rem;
		border: none;
		color: white;
		background-color: #d4ae69;
		font-size: 1.4rem;
	}

	.index-carousel-message,
	.index-carousel-cta {
		z-index: 5;
		top: 55%;
	} */
	}

	.index-description > span {
		font-size: 2.6rem;
	}

	.index-description > span > span {
		color: #c7222a;
		
	}

	.index-steps {
		display: flex;
		flex-direction: column;
		width: 100%;
		margin: 1.5rem 0;
		padding: 0 0 0 1.5rem;
	}

	.index-steps > span {
		display: flex;
		align-items: center;
		color: #212529;
	}

	.index-steps > span > span {
		padding: 1rem 0 1rem 1rem;
		font-size: 1.6rem;
		color: #212529;
	}

	.index-steps-icon-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 3rem;
		width: 3rem;
		border-radius: 3rem;
		background-color: #c7222a;
		z-index: 1;
	}

	.index-steps-line {
		position: relative;
		right: 1.5rem;
		height: 100%;
		border-right: 0.1rem dashed #c7222a;
		border-left: 0.1rem dashed #c7222a;
		z-index: 0;
	}

	.index-steps-line-first {
		height: 50%;
		top: 25%;
	}

	.index-steps-line-last {
		height: 50%;
		bottom: 25%;
	}

	.index-documents-card {
		background-color: #F9EAD0;
		width: 100%;
		padding: 1.5rem 0;
		color: #000 !important;
		font-weight: 500 !important;
	}

	.index-documents-card > h2 {
		margin: 0 1.5rem;
	}

	.index-documents-list {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 1.5rem;
		background-color: #c7222a;
		color: white;
		padding: 1.6rem 1.6rem 1rem 1.6rem;
		border-radius: 0.6rem;
		padding: 0;
	}

	.index-documents-list > img {
		border-bottom-right-radius: 0.6rem;
	}

	.index-documents-list > h2 {
		font-size: 2rem;
	}

	.index-documents-list > ul {
		margin-left: 1.5rem;
		padding-left: 1em;
		margin-bottom: 0;
	}

	.index-dropdown {
		display: flex;
		justify-content: center;
		width: 100%;
		margin-top: 1.5rem;
	}

	.accordion-container {
		padding: 0 2.4rem 0 2rem;
	}

	.accordion-container {
		width: 100%;
		padding-bottom: 10px;
	}

	.illus{
		font-size: 15px;
	}

	#illus1{
		padding-bottom: 70px;
	}


	.index-cta {
		display: flex;
		justify-content: center;
		width: 100%;
		margin: 1.5rem 0;
		height: 4rem;
	}

	@media only screen and (max-width: 768px) {
		.index-layout {
			width: 100%;
		}
	}
`;
